(() => {
  const GALLERY_PATH = "/pages/the-gallery";
  const MAX_TILT = 3.5;
  const LIFT = 7;
  const EASING = 0.11;

  function initialiseGalleryCards(root = document) {
    if (!window.location.pathname.includes(GALLERY_PATH)) return;

    const images = root.querySelectorAll("main img");

    images.forEach((image) => {
      if (image.dataset.sonaTiltReady === "true") return;

      image.dataset.sonaTiltReady = "true";
      image.classList.add("sona-tilt-card");

      let currentX = 0;
      let currentY = 0;
      let currentLift = 0;

      let targetX = 0;
      let targetY = 0;
      let targetLift = 0;

      let animationFrame;

      function animate() {
        currentX += (targetX - currentX) * EASING;
        currentY += (targetY - currentY) * EASING;
        currentLift += (targetLift - currentLift) * EASING;

        image.style.transform = `
          perspective(1000px)
          translate3d(0, ${currentLift}px, 0)
          rotateX(${currentX}deg)
          rotateY(${currentY}deg)
        `;

        const stillMoving =
          Math.abs(targetX - currentX) > 0.01 ||
          Math.abs(targetY - currentY) > 0.01 ||
          Math.abs(targetLift - currentLift) > 0.01;

        if (stillMoving) {
          animationFrame = requestAnimationFrame(animate);
        } else {
          animationFrame = null;
        }
      }

      function startAnimation() {
        if (!animationFrame) {
          animationFrame = requestAnimationFrame(animate);
        }
      }

      image.addEventListener("pointermove", (event) => {
        if (event.pointerType === "touch") return;

        const rect = image.getBoundingClientRect();
        const x = (event.clientX - rect.left) / rect.width;
        const y = (event.clientY - rect.top) / rect.height;

        /*
          Positive rotateY makes the card lean toward the right.
          Negative rotateX makes the upper area dip toward the cursor.
        */
        targetY = (x - 0.5) * MAX_TILT * 2;
        targetX = (0.5 - y) * MAX_TILT * 2;
        targetLift = -LIFT;

        startAnimation();
      });

      image.addEventListener("pointerleave", () => {
        targetX = 0;
        targetY = 0;
        targetLift = 0;

        startAnimation();
      });
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    initialiseGalleryCards();
  });

  document.addEventListener("shopify:section:load", (event) => {
    initialiseGalleryCards(event.target);
  });
})();